import React from 'react';
import cn from 'classnames';
import { TitleDesktop } from '@alfalab/core-components-typography/esm';

var styles = {"header":"confirmation__header_dth92","typography":"confirmation__typography_dth92","typographyMobile":"confirmation__typographyMobile_dth92"};
require('./index.css')

var Header = function (_a) {
    var _b;
    var mobile = _a.mobile, children = _a.children;
    return (React.createElement(TitleDesktop, { className: cn(styles.header, styles.typography, (_b = {}, _b[styles.typographyMobile] = mobile, _b)), tag: 'h3', color: 'primary' }, children));
};

export { Header };
